import { UserType } from "@app/types/genericTables.types";
import {
  IFormFilterTransitDose,
  IFormTransitDose,
  PayloadTransitDose,
  TransitDoseListType,
} from "@app/types/transitDose.types";
import { formatDateOrNow } from "@app/utils/formatDate";
import { convertToNumber } from "@app/utils/functions";
import dayjs from "dayjs";

export function filterTransit(
  filters: IFormFilterTransitDose,
  transitList: TransitDoseListType[]
) {
  const { instalation, registration_date_from, registration_date_to } = filters;

  return transitList.filter((transit) => {
    const registrationDate = dayjs(transit.registration_date).format(
      "YYYY-MM-DD"
    );
    const registrationDateFrom = dayjs(registration_date_from).format(
      "YYYY-MM-DD"
    );
    const registrationDateTo = dayjs(registration_date_to).format("YYYY-MM-DD");

    return (
      (!instalation || transit.instalation.id === Number(instalation.id)) &&
      (!registration_date_from || registrationDate >= registrationDateFrom) &&
      (!registration_date_to || registrationDate <= registrationDateTo)
    );
  });
}

export const getDefaultValuesTransitDose = (
  transitDose?: TransitDoseListType,
  user?: UserType
): IFormTransitDose => {
  return {
    id: transitDose?.id,
    analyst: transitDose?.analyst || user,
    registration_date: formatDateOrNow(transitDose?.registration_date),
    instalation: transitDose?.instalation || undefined,
    average_delete_date: transitDose?.average_delete_date || undefined,
    average_read_date: transitDose?.average_read_date || undefined,
    transit_days: transitDose?.transit_days || undefined,
    crystal_1_transit_1: transitDose?.crystal_1_transit_1 || undefined,
    crystal_2_transit_1: transitDose?.crystal_2_transit_1 || undefined,
    crystal_3_transit_1: transitDose?.crystal_3_transit_1 || undefined,
    crystal_4_transit_1: transitDose?.crystal_4_transit_1 || undefined,
    crystal_1_transit_2: transitDose?.crystal_1_transit_2 || undefined,
    crystal_2_transit_2: transitDose?.crystal_2_transit_2 || undefined,
    crystal_3_transit_2: transitDose?.crystal_3_transit_2 || undefined,
    crystal_4_transit_2: transitDose?.crystal_4_transit_2 || undefined,
    timely_dose_of_traffic: transitDose?.timely_dose_of_traffic || undefined,
    timely_dose_of_traffic_current:
      transitDose?.timely_dose_of_traffic || undefined,
    error_in_transit_dose: transitDose?.error_in_transit_dose || undefined,
    history_average_transit_dose:
      transitDose?.history_average_transit_dose || undefined,
    history_error_in_transit_dose:
      transitDose?.history_error_in_transit_dose || undefined,
  };
};

export function stdevS(values) {
  const validValues = values.filter(
    (value) => typeof value === "number" && !isNaN(value)
  );
  const n = validValues.length;

  if (n <= 1) {
    return 0;
  }

  const mean = validValues.reduce((sum, value) => sum + value, 0) / n;

  const sumSquaredDifferences = validValues.reduce(
    (sum, value) => sum + Math.pow(value - mean, 2),
    0
  );

  const standardDeviation = Math.sqrt(sumSquaredDifferences / (n - 1));

  return standardDeviation;
}

export const getTop3ById = (data: TransitDoseListType[]) => {
  if (!data || data.length === 0) {
    return [];
  }

  return data
    .slice()
    .sort((a, b) => b.id - a.id)
    .slice(0, 3);
};

export const processHistoryDoses = (previusData, currentPunctualData) => {
  const setTimelyDoseOfTraffic = previusData.map(
    (item) => item.timely_dose_of_traffic
  );
  currentPunctualData > 0 &&
    setTimelyDoseOfTraffic.push(convertToNumber(currentPunctualData));

  const totalSum = setTimelyDoseOfTraffic.reduce(
    (sum, item) => sum + convertToNumber(item),
    0
  );

  const average = totalSum / setTimelyDoseOfTraffic.length;

  const totalDiff = setTimelyDoseOfTraffic.reduce((sum, item) => {
    const timelyDiff = Math.pow(item - Number(average), 2);
    return sum + timelyDiff;
  }, 0);

  const calculatedStdev = Math.sqrt(
    totalDiff * (1 / (setTimelyDoseOfTraffic.length - 1))
  );

  return { average, calculatedStdev };
};

export const historyDosesConfig = [
  { label: "Última", value: "timely_dose_of_traffic_current" },
  {
    label: "1ª anterior",
    value: "timely_dose_of_traffic_previous",
  },
  {
    label: "2ª anterior",
    value: "timely_dose_of_traffic_previous_2",
  },
  {
    label: "3ª anterior",
    value: "timely_dose_of_traffic_previous_3",
  },
];

export const mappingDoses = (data: IFormTransitDose): PayloadTransitDose => {
  return {
    ...data,
    analyst: data.analyst?.id ?? undefined,
    instalation: data.instalation?.id ?? undefined,
  };
};
